<aw-section
  testIdAffix="appearance-highlighted-actions"
  [isCollapsible]="true"
  [forceCollapse]="forceCollapse()"
  [withoutContentPadding]="true">
  <aw-section-header>
    <span class="text-standard-text-primary text-2xl font-semibold">
      {{ cmsTextProvider.appearanceText.ctaHeader }}
    </span>
  </aw-section-header>

  <div
    class="grid grid-cols-1 gap-6 pt-7 xl:grid-cols-[minmax(12rem,1fr)_minmax(0,4fr)]">
    <h3 class="text-standard-text-primary ml-8 text-xl font-semibold">
      {{ cmsTextProvider.appearanceText.ctaColours }}
    </h3>

    <div class="min-w-0">
      <p class="text-standard-text-secondary text-m mb-2 leading-5">
        {{ cmsTextProvider.appearanceText.ctaColoursHint }}
      </p>

      <div class="grid grid-cols-1 gap-3 2xl:grid-cols-2">
        <ng-container
          *ngTemplateOutlet="ctaPreviewCard; context: { dark: false }" />
        <ng-container
          *ngTemplateOutlet="ctaPreviewCard; context: { dark: true }" />
      </div>
    </div>
  </div>

  <hr class="my-8" />

  <aw-appearance-font-upload (draftChange)="fontDraftChange.emit($event)" />
</aw-section>

<ng-template #ctaPreviewCard let-dark="dark">
  <aw-theme context="shop" [mode]="dark ? 'dark' : 'light'" [design]="design()">
    <article class="rounded-[0.375rem] border">
      <div class="flex justify-end px-3 pt-3">
        <span
          class="inline-flex h-8 items-center justify-center gap-1.5 rounded-full border px-2.5 py-0 text-sm leading-none border-standard-outline">
          <span
            aria-hidden="true"
            class="material-symbols-rounded icon-filled inline-flex size-5 shrink-0 items-center justify-center !text-lg leading-none">
            {{ dark ? 'dark_mode' : 'light_mode' }}
          </span>
          <span class="inline-flex h-5 items-center leading-none">
            {{
              dark
                ? cmsTextProvider.appearanceText.controlsDarkMode
                : cmsTextProvider.appearanceText.controlsLightMode
            }}
          </span>
        </span>
      </div>

      <div class="flex flex-col gap-2 p-3">
        <aw-button type="button" [id]="'1'" [style]="'secondary'" [buttonSize]="'small'">
            <span class="material-symbols-rounded">add</span>
            {{ cmsTextProvider.appearanceText.ctaPrimaryAction }}
          </aw-button>

          <aw-button type="button" [id]="'2'" [style]="'secondary-alt'" [buttonSize]="'small'">
            <span class="material-symbols-rounded">add</span>
            {{ cmsTextProvider.appearanceText.ctaSecondaryAction }}
          </aw-button>
      </div>

      <div class="mx-3 border-t border-standard-outline"></div>

      <div class="flex flex-col gap-3 p-3">
        @for (color of colors; track color.key) {
          <div>
            <div class="relative flex items-center gap-2 text-base">
              <aw-color-picker-list 
                [color]="swatchColor(color.key, dark)"
                (colorChanged)="selectColor(color.key, dark, $event)"></aw-color-picker-list>
              <span>{{ color.label }}</span>
            </div>

            @if (color.description) {
              <p
                class="mt-1 pl-8 text-sm leading-5"
                [ngClass]="dark ? 'text-neutral-400' : 'text-neutral-500'">
                {{ color.description }}
              </p>
            }
          </div>
        }
      </div>
    </article>
  </aw-theme>
</ng-template>
